import { Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { User } from "@overmap-ai/common"
import { memo } from "react"

import { getUserDisplayLabel } from "../../utils/users"
import { UserIcon } from "../Icons/UserIcon"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type UserSelectGroupProps = MenuSelectGroupProps<User> & {
	users: User[]
}

export const UserSelectGroup = memo<UserSelectGroupProps>((props) => {
	const { ref, users, ...rest } = props

	return (
		<Menu.SelectGroup<User> ref={ref} {...rest}>
			{users.map((user) => {
				return (
					<SelectItemTemplate<User> key={user.id} value={user} className="truncate">
						<UserIcon userId={user.id} size="xs" />
						<Text className="truncate">{getUserDisplayLabel(user)}</Text>
					</SelectItemTemplate>
				)
			})}
		</Menu.SelectGroup>
	)
})
UserSelectGroup.displayName = "UserSelectGroup"
